import React from "react";
import LibraryParity from "./LibraryParity";
export default function Monographs() { return <LibraryParity kind="monographs" />; }
